import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { TruncatedText } from "./TruncatedText.js";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { useCardContext } from "./context.js";
function Header({
  thumbnail,
  title,
  detail,
  icon,
  isNotTruncated = false,
  ...props
}) {
  const {
    cardTitleId
  } = useCardContext();
  return /* @__PURE__ */ jsxs(HeaderStyled, {
    ...props,
    children: [thumbnail ? /* @__PURE__ */ jsx(ThumbnailContainer, {
      children: thumbnail
    }) : null, /* @__PURE__ */ jsx(Title, {
      id: cardTitleId,
      children: isNotTruncated ? title : /* @__PURE__ */ jsx(TruncatedText, {
        children: title
      })
    }), detail ? /* @__PURE__ */ jsx(Detail, {
      children: isNotTruncated ? detail : /* @__PURE__ */ jsx(TruncatedText, {
        children: detail
      })
    }) : null, icon ? /* @__PURE__ */ jsx(IconContainer, {
      children: icon
    }) : null]
  });
}
const HeaderStyled = styled.div.withConfig({
  displayName: "HeaderStyled",
  componentId: "sc-1pov1j3-0"
})(["display:grid;grid-template-areas:'thumbnail title icon' 'thumbnail detail icon';grid-template-columns:auto 1fr auto;padding:var(--card-content-padding);"]);
const ThumbnailContainer = styled.div.withConfig({
  displayName: "ThumbnailContainer",
  componentId: "sc-1pov1j3-1"
})(["grid-area:thumbnail;margin-top:2px;margin-right:", ";"], token.spacing4);
const Title = styled.div.withConfig({
  displayName: "Title",
  componentId: "sc-1pov1j3-2"
})(["", " grid-area:title;min-width:0;color:", ";overflow-wrap:break-word;"], textStyles.uiTextM, token.colorText);
const Detail = styled.div.withConfig({
  displayName: "Detail",
  componentId: "sc-1pov1j3-3"
})(["", " grid-area:detail;min-width:0;margin-top:", ";color:", ";overflow-wrap:break-word;"], textStyles.uiTextS, token.spacing2, token.colorTextMuted);
const IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1pov1j3-4"
})(["z-index:2;display:grid;grid-area:icon;align-items:center;margin-left:", ";color:", ";"], token.spacing2, token.gray600);
export {
  Header
};
//# sourceMappingURL=Header.js.map
